import SubmitButton from './SubmitButton'

export default SubmitButton



// WEBPACK FOOTER //
// ./src/components/SubmitButton/index.js